import React from 'react';
import { TrendingUp, Clock, Briefcase, Shield, CheckCircle, Award } from 'lucide-react';
export const Features = () => {
  const features = [{
    icon: <TrendingUp size={28} className="text-primary-600" data-id="element-656" />,
    title: 'Business Growth',
    description: 'Strategic capital to expand operations, hire talent, and reach new markets across Kenya and East Africa.'
  }, {
    icon: <Clock size={28} className="text-primary-600" data-id="element-657" />,
    title: 'Quick Approval',
    description: 'Streamlined digital application with decisions in 1-12 hours. No unnecessary delays or bureaucracy.'
  }, {
    icon: <Briefcase size={28} className="text-primary-600" data-id="element-658" />,
    title: 'Flexible Terms',
    description: 'Customized repayment schedules aligned with your business cash flow and seasonal patterns.'
  }, {
    icon: <Shield size={28} className="text-primary-600" data-id="element-659" />,
    title: 'Transparent Pricing',
    description: 'No hidden fees or surprises. Clear terms and competitive rates you can trust from day one.'
  }, {
    icon: <CheckCircle size={28} className="text-primary-600" data-id="element-660" />,
    title: 'Expert Support',
    description: 'Dedicated relationship managers who understand your industry and business challenges.'
  }, {
    icon: <Award size={28} className="text-primary-600" data-id="element-661" />,
    title: 'Proven Track Record',
    description: 'Over 6 years of empowering Kenyan SMEs with a 94% client satisfaction rating.'
  }];
  return <section className="py-20 bg-white" data-id="element-662">
      <div className="container" data-id="element-663">
        <div className="text-center mb-16" data-id="element-664">
          <h2 className="section-title" data-id="element-665">Why Choose Geldhaus</h2>
          <p className="section-subtitle" data-id="element-666">
            We're committed to supporting Kenyan entrepreneurs with financial
            solutions that drive real, sustainable success.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-667">
          {features.map((feature, index) => <div key={index} className="group bg-white p-8 rounded-2xl border-2 border-gray-100 hover:border-primary-200 hover:shadow-xl transition-all duration-300 card-hover" data-id="element-668">
              <div className="mb-5 w-14 h-14 bg-primary-50 rounded-xl flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-300" data-id="element-669">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-670">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-671">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};